<template>
  <v-dialog v-model="dialog" max-width="700" persistent scrollable>
    <v-card>
      <v-card-title class="text-h5 blue-grey darken-2 white--text">
        <v-icon left dark>mdi-car</v-icon>
        {{ isEdit ? "Edit" : "Add" }} Vehicle
      </v-card-title>

      <v-card-text class="pt-6">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.make"
                label="Make"
                :rules="[rules.required]"
                outlined
                dense
                placeholder="e.g., Toyota, BMW"
              >
                <template v-slot:prepend>
                  <v-icon>mdi-car</v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.model"
                label="Model"
                :rules="[rules.required]"
                outlined
                dense
                placeholder="e.g., Corolla, 3 Series"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.year"
                label="Year"
                type="number"
                :rules="[rules.required, rules.year]"
                outlined
                dense
                placeholder="e.g., 2020"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.color"
                label="Color"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.registration"
                label="Registration Number"
                :rules="[rules.required]"
                outlined
                dense
              >
                <template v-slot:prepend>
                  <v-icon>mdi-card-account-details</v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.vin"
                label="VIN (Vehicle Identification Number)"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.mileage"
                label="Current Mileage (km)"
                type="number"
                outlined
                dense
              >
                <template v-slot:append>
                  <span class="text-caption">km</span>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.engine_number"
                label="Engine Number"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.fuel_type"
                label="Fuel Type"
                outlined
                dense
                placeholder="e.g., Petrol, Diesel"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.transmission"
                label="Transmission"
                outlined
                dense
                placeholder="e.g., Manual, Automatic"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="formData.notes"
                label="Additional Notes"
                outlined
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog"> Cancel </v-btn>
        <v-btn
          color="blue-grey darken-2"
          dark
          @click="saveVehicle"
          :disabled="!valid"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save Vehicle
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AddVehicleDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    vehicle: {
      type: Object,
      default: null,
    },
    clientId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    valid: false,
    formData: {
      make: "",
      model: "",
      year: "",
      color: "",
      registration: "",
      vin: "",
      mileage: "",
      engine_number: "",
      fuel_type: "",
      transmission: "",
      notes: "",
    },
    rules: {
      required: (v) => !!v || "This field is required",
      year: (v) => {
        const year = parseInt(v);
        const currentYear = new Date().getFullYear();
        return (year >= 1900 && year <= currentYear + 1) || "Invalid year";
      },
    },
  }),

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    isEdit() {
      return this.vehicle !== null;
    },
  },

  watch: {
    value(val) {
      if (val && this.vehicle) {
        this.formData = { ...this.vehicle };
      } else if (val) {
        this.resetForm();
      }
    },
  },

  methods: {
    saveVehicle() {
      if (this.$refs.form.validate()) {
        this.$emit("save", {
          ...this.formData,
          client_id: this.clientId,
        });
        this.closeDialog();
      }
    },

    closeDialog() {
      this.$emit("input", false);
      this.$emit("close");
      this.resetForm();
    },

    resetForm() {
      this.formData = {
        make: "",
        model: "",
        year: "",
        color: "",
        registration: "",
        vin: "",
        mileage: "",
        engine_number: "",
        fuel_type: "",
        transmission: "",
        notes: "",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
